import { FC } from 'react';
import ItemList from '../display/ItemList';
import TextInputField from '../inputs/TextInputField';
import ErrorText from '../texts/ErrorText';
import { getPropertyIcon } from '../../settings/icons';
import { Box, SxProps, Theme } from '@mui/material';

interface IProps 
{
    property: IPropertyState;
    onChange: (value: string)=>void;
    onAdd?: (value: string)=>void;
    onDelete?: (handle: number)=>void;
    sx?: SxProps<Theme>;
}

const TextProperty: FC<IProps> = ({ property, onChange, onAdd, onDelete, sx }) => 
{
    const icon = property.icon ?? getPropertyIcon(property.type);
    const showList = (property.array && property.valueList.length > 0) ? false : true;
    
    return (<Box sx={{mb: 3, mt: 3, ...sx}}>
        <TextInputField 
            title={property.title}
            value={property.value as string}
            icon={icon}
            type={property.secret ? "password" : "text"}
            onChange={onChange}
            onAdd={onAdd}
        />
        {property.errors?.map(error=>{
            return (<ErrorText key={`text-property-error-${property.id}`} sx={{marginLeft: "8px", fontSize: 14}}>
                - {error}
            </ErrorText>)
        })}
        <ItemList 
            items={property.valueList.map(val=>({title: val, icon: icon}))}
            onDeleteRequest={onDelete} 
            hideIfEmpty={showList}
        />
    </Box>);
};

export default TextProperty;